import React, { useState } from 'react';
import { HiArrowLeft, HiCalendar, HiClock, HiUsers, HiUser, HiChatBubbleOvalLeftEllipsis, HiPaperAirplane, HiPhone, HiShoppingBag, HiCreditCard } from 'react-icons/hi2';

const BookingForm = ({ onBack, onSubmit, cafeName, cart = [], total = 0, onSelectMenu, joinMode = false, parentData = null }) => {
    const [formData, setFormData] = useState({
        name: '',
        whatsapp: '', // [BARU] Field WA
        date: '',
        time: '',
        pax: '',
        notes: '',
        dpOption: 'dp30' // [BARU] Default DP 30%
    });

    // [BARU] Hitung nominal DP
    const dpAmount = formData.dpOption === 'lunas' ? total : Math.ceil(total * 0.3);
    const sisaPembayaran = total - dpAmount;

    // [BARU] Initialize default data
    React.useEffect(() => {
        if (joinMode && parentData) {
            // Jika join mode, prepopulate data dari parent & set readonly (UI handled separately)
            setFormData(prev => ({
                ...prev,
                date: parentData.bookingDate,
                time: parentData.bookingTime,
                pax: 1 // Default 1 for joiner (usually themselves)
            }));
        } else if (!formData.time) {
            const now = new Date();
            now.setHours(now.getHours() + 1);
            const h = now.getHours().toString().padStart(2, '0');
            setFormData(prev => ({ ...prev, time: `${h}:00` }));
        }
    }, [joinMode, parentData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // SUBMIT INTERNAL: Panggil prop onSubmit (ke App.jsx)
        // Data ini akan dipakai untuk membuat 'Order' tipe 'booking' di Firestore
        if (onSubmit) {
            onSubmit(formData);
        }
    };

    // Get today's date for min attribute
    const today = new Date().toISOString().split('T')[0];

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            {/* Header */}
            <div className="bg-white p-4 shadow-sm flex items-center gap-4 sticky top-0 z-10">
                <button onClick={onBack} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                    <HiArrowLeft size={20} className="text-gray-600" />
                </button>
                <div>
                    <h1 className="font-semibold text-lg text-gray-800">{joinMode ? 'Gabung Bukber' : 'Formulir Reservasi'}</h1>
                    {joinMode && parentData && (
                        <p className="text-xs text-emerald-600 font-medium">Link: {parentData.customerName}</p>
                    )}
                </div>
            </div>

            {/* Form */}
            <div className="flex-grow p-6 max-w-md mx-auto w-full pb-32">
                <form onSubmit={handleSubmit} className="space-y-6">

                    {/* [BARU] Section Pre-order Menu */}
                    <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4">
                        <div className="flex justify-between items-center mb-3">
                            <h3 className="font-bold text-emerald-800 flex items-center gap-2">
                                <HiShoppingBag size={18} /> Menu Bukber (Pre-order)
                            </h3>
                            {cart.length > 0 && (
                                <span className="bg-emerald-200 text-emerald-800 text-xs px-2 py-1 rounded-full font-bold">
                                    {cart.reduce((sum, item) => sum + item.quantity, 0)} Item
                                </span>
                            )}
                        </div>

                        {cart.length === 0 ? (
                            <div className="text-center py-4">
                                <p className="text-sm text-emerald-600 mb-3">Belum ada menu yang dipilih.</p>
                                <button
                                    type="button"
                                    onClick={onSelectMenu}
                                    className="bg-white border border-emerald-500 text-emerald-600 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-emerald-50 transition-colors shadow-sm w-full"
                                >
                                    + Pilih Menu Sekarang
                                </button>
                                <p className="text-[10px] text-emerald-500 mt-2 italic">
                                    *Sangat disarankan pesan menu agar siap saat berbuka.
                                </p>
                            </div>
                        ) : (
                            <div className="space-y-3">
                                <ul className="space-y-2 max-h-40 overflow-y-auto pr-1 custom-scrollbar">
                                    {cart.map((item, idx) => (
                                        <li key={idx} className="flex justify-between text-sm border-b border-emerald-100 pb-1 last:border-0">
                                            <span className="text-gray-700 truncate w-2/3">
                                                <span className="font-bold text-emerald-700">{item.quantity}x</span> {item.name}
                                            </span>
                                            <span className="font-medium text-gray-900">
                                                {new Intl.NumberFormat("id-ID").format(item.price * item.quantity)}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                                <div className="border-t border-emerald-200 pt-2 flex justify-between font-bold text-emerald-900">
                                    <span>Total Estimasi</span>
                                    <span>Rp {new Intl.NumberFormat("id-ID").format(total)}</span>
                                </div>
                                <button
                                    type="button"
                                    onClick={onSelectMenu}
                                    className="text-xs text-emerald-600 underline hover:text-emerald-800 mt-1 block text-right"
                                >
                                    Ubah / Tambah Menu
                                </button>
                            </div>
                        )}
                    </div>

                    {/* [BARU] Opsi Pembayaran DP - Hanya untuk Ketua */}
                    {!joinMode && cart.length > 0 && (
                        <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                            <h3 className="font-bold text-purple-800 flex items-center gap-2 mb-3">
                                <HiCreditCard size={18} /> Opsi Pembayaran
                            </h3>
                            <div className="space-y-3">
                                {/* DP 30% Option */}
                                <label className={`flex items-center justify-between p-3 rounded-lg border-2 cursor-pointer transition-all ${formData.dpOption === 'dp30'
                                        ? 'border-purple-500 bg-purple-100'
                                        : 'border-gray-200 bg-white hover:border-purple-300'
                                    }`}>
                                    <div className="flex items-center gap-3">
                                        <input
                                            type="radio"
                                            name="dpOption"
                                            value="dp30"
                                            checked={formData.dpOption === 'dp30'}
                                            onChange={handleChange}
                                            className="w-4 h-4 text-purple-600"
                                        />
                                        <div>
                                            <p className="font-semibold text-gray-800">DP 30%</p>
                                            <p className="text-xs text-gray-500">Bayar sisa saat datang</p>
                                        </div>
                                    </div>
                                    <span className="font-bold text-purple-700">
                                        Rp {new Intl.NumberFormat('id-ID').format(Math.ceil(total * 0.3))}
                                    </span>
                                </label>

                                {/* Lunas Option */}
                                <label className={`flex items-center justify-between p-3 rounded-lg border-2 cursor-pointer transition-all ${formData.dpOption === 'lunas'
                                        ? 'border-purple-500 bg-purple-100'
                                        : 'border-gray-200 bg-white hover:border-purple-300'
                                    }`}>
                                    <div className="flex items-center gap-3">
                                        <input
                                            type="radio"
                                            name="dpOption"
                                            value="lunas"
                                            checked={formData.dpOption === 'lunas'}
                                            onChange={handleChange}
                                            className="w-4 h-4 text-purple-600"
                                        />
                                        <div>
                                            <p className="font-semibold text-gray-800">Bayar Lunas</p>
                                            <p className="text-xs text-gray-500">Tidak perlu bayar lagi</p>
                                        </div>
                                    </div>
                                    <span className="font-bold text-purple-700">
                                        Rp {new Intl.NumberFormat('id-ID').format(total)}
                                    </span>
                                </label>
                            </div>

                            {/* Summary */}
                            <div className="mt-4 pt-3 border-t border-purple-200 space-y-1">
                                <div className="flex justify-between text-sm">
                                    <span className="text-gray-600">Bayar Sekarang:</span>
                                    <span className="font-bold text-purple-800">Rp {new Intl.NumberFormat('id-ID').format(dpAmount)}</span>
                                </div>
                                {formData.dpOption === 'dp30' && (
                                    <div className="flex justify-between text-sm">
                                        <span className="text-gray-600">Sisa Bayar di Tempat:</span>
                                        <span className="font-semibold text-gray-700">Rp {new Intl.NumberFormat('id-ID').format(sisaPembayaran)}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Nama */}
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                            <HiUser size={16} className="text-emerald-600" /> Nama Pemesan
                        </label>
                        <input
                            type="text"
                            name="name"
                            required
                            placeholder="Nama Lengkap"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                        />
                    </div>

                    {/* WhatsApp [BARU] - Hanya untuk Ketua */}
                    {!joinMode && (
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                                <HiPhone size={16} className="text-emerald-600" /> Nomor WhatsApp
                            </label>
                            <input
                                type="tel"
                                name="whatsapp"
                                required
                                placeholder="Contoh: 081234567890"
                                value={formData.whatsapp}
                                onChange={handleChange}
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                            />
                            <p className="text-xs text-gray-400">Wajib diisi untuk konfirmasi booking.</p>
                        </div>
                    )}

                    {joinMode ? (
                        <div className="bg-blue-50 border border-blue-200 p-4 rounded-xl space-y-2">
                            <div className="flex items-center gap-2 text-blue-800 font-bold">
                                <HiCalendar size={18} />
                                <span>{parentData?.bookingDate || formData.date}</span>
                            </div>
                            <div className="flex items-center gap-2 text-blue-800 font-bold">
                                <HiClock size={18} />
                                <span>{parentData?.bookingTime || formData.time}</span>
                            </div>
                            <p className="text-xs text-blue-600">
                                Anda bergabung ke acara bukber <strong>{parentData?.customerName}</strong>.
                                Jam dan tanggal mengikuti ketua grup.
                            </p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-2 gap-4">
                            {/* Tanggal */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                                    <HiCalendar size={16} className="text-emerald-600" /> Tanggal
                                </label>
                                <input
                                    type="date"
                                    name="date"
                                    required
                                    min={today}
                                    value={formData.date}
                                    onChange={handleChange}
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                                />
                            </div>

                            {/* Jam (Custom 24H Picker) */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                                    <HiClock size={16} className="text-emerald-600" /> Jam
                                </label>
                                <div className="flex gap-2">
                                    <select
                                        name="hour"
                                        value={formData.time ? formData.time.split(':')[0] : ''}
                                        onChange={(e) => {
                                            const h = e.target.value;
                                            const m = formData.time ? formData.time.split(':')[1] : '00';
                                            setFormData(prev => ({ ...prev, time: `${h}:${m}` }));
                                        }}
                                        className="flex-1 p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none bg-white"
                                        required
                                    >
                                        <option value="" disabled>Jam</option>
                                        {Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')).map(h => (
                                            <option key={h} value={h}>{h}</option>
                                        ))}
                                    </select>
                                    <span className="flex items-center text-gray-400">:</span>
                                    <select
                                        name="minute"
                                        value={formData.time ? formData.time.split(':')[1] : ''}
                                        onChange={(e) => {
                                            const m = e.target.value;
                                            const h = formData.time ? formData.time.split(':')[0] : '12';
                                            setFormData(prev => ({ ...prev, time: `${h}:${m}` }));
                                        }}
                                        className="flex-1 p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 outline-none bg-white"
                                        required
                                    >
                                        {Array.from({ length: 12 }, (_, i) => (i * 5).toString().padStart(2, '0')).map(m => (
                                            <option key={m} value={m}>{m}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Jumlah Orang - Hanya untuk Ketua (Default 1 untuk joiner) */}
                    {!joinMode && (
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                                <HiUsers size={16} className="text-emerald-600" /> Jumlah Orang
                            </label>
                            <input
                                type="number"
                                name="pax"
                                required
                                min="1"
                                placeholder="Berapa orang?"
                                value={formData.pax}
                                onChange={handleChange}
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                            />
                            <p className="text-xs text-gray-400">Termasuk anak-anak jika butuh kursi</p>
                        </div>
                    )}

                    {/* Catatan - Hanya untuk Ketua */}
                    {!joinMode && (
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                                <HiChatBubbleOvalLeftEllipsis size={16} className="text-emerald-600" /> Catatan Tambahan
                            </label>
                            <textarea
                                name="notes"
                                rows="3"
                                placeholder="Contoh: Meja smoking area, kursi bayi..."
                                value={formData.notes}
                                onChange={handleChange}
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all resize-none"
                            ></textarea>
                        </div>
                    )}

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full bg-emerald-600 text-white font-semibold py-4 rounded-xl shadow-lg hover:bg-emerald-700 active:scale-95 transition-all flex items-center justify-center gap-2"
                    >
                        <HiPaperAirplane size={20} />
                        {joinMode ? 'Gabung & Pesan Menu' : 'Kirim Booking ke Kasir'}
                    </button>

                    <p className="text-center text-xs text-gray-400 mt-4">
                        Status booking Anda akan muncul di riwayat 'Pesan' aplikasi ini.
                    </p>
                </form>
            </div >
        </div >
    );
};

export default BookingForm;
